import * as dateFnsCompat from 'utils/date-fns-compat';
import he from 'he';
import fp from 'lodash/fp';
import prettyBytes from 'pretty-bytes';
import queryString from 'query-string';
import React, { Component } from 'react';
import { Button, Col, Grid, Modal, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Spinner from 'react-spinkit';
import { compose, withProps } from 'recompose';
import {
  contentStatus,
  contentType,
  months,
  cpdCategoryType,
  accreditationNames
} from '../../../../constants';
import {
  focusElement,
  handleInvalidForm,
  isSystemAdmin,
  isNonEmptyString,
  isNonEmptyNumber
} from '../../../../services';
import { contentConfigSelector } from '../../../../state/modules/configuration/selectors';
import { activePublishersSelector } from '../../../../state/modules/publisher-portal/publisher/selectors';
import { currentUserSelector } from '../../../../state/modules/user';
import { noCapFilter, noCapMap, toSafeExternalUrl } from '../../../../utils';
import {
  ConfirmationModal,
  ControlGroup,
  ControlOption,
  FileUploadFormField,
  FormField,
  FormGroup,
  FormItem,
  Icon,
  ImageCropField,
  InputFormField,
  NumberFormField,
  SelectFormField,
  ServerError,
  TextAreaFormField
} from '../../../components';
import Loading from '../../loading';
import _ from 'lodash';
import { LinkContainer } from 'react-router-bootstrap';
import {
  downloadBlobStreamFile,
  getBlobStream,
  getCsvStream,
  writeDataToCsvStream
} from '../../../../utils';
import { syncCpdCategoryWithGoals } from '../../shared/syncCpdCategoryWithGoals';
import {
  filterActiveStatus,
  filterNonLegacyOrPublisherVisible
} from '../../../../common/cpd-category-filter';
import { transcriptSupportedContentTypes } from '../../../../constants/content-type';

const updateContentConfirmationMessage = ({
  cpdCategorysChanged,
  passedUserEmails
}) => {
  return !cpdCategorysChanged ? (
    <div>
      <p>
        Detected no change to CPD categories. Would you like to update the
        content?
      </p>
    </div>
  ) : passedUserEmails.length === 0 ? (
    <div>
      <p>
        There are no users who had completed this content yet. Would you like to
        update the content?
      </p>
    </div>
  ) : (
    <div>
      <p>
        This content has already been completed by {passedUserEmails.length}{' '}
        users. Choose how you'd like the updates to apply.
      </p>
      <hr style={{ border: 'none', borderTop: '1px solid #ccc' }} />
      <ol
        style={{
          maxHeight: '500px',
          overflowY: 'auto',
          paddingLeft: 0,
          marginLeft: '30%',
          paddingRight: '1em',
          width: '70%'
        }}
      >
        {passedUserEmails.map((email, idx) => (
          <li
            key={idx}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginBottom: '4px',
              listStyle: 'none',
              wordBreak: 'break-word'
            }}
          >
            <span
              style={{
                display: 'inline-block',
                textAlign: 'right',
                paddingRight: '0.5em',
                fontVariantNumeric: 'tabular-nums',
                flexShrink: 0
              }}
            >
              {idx + 1}.
            </span>
            <span
              style={{
                flex: 1,
                textAlign: 'left',
                display: 'block'
              }}
            >
              {email}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
};
class ContentDetails extends Component {
  constructor() {
    super();

    this.state = {
      content: {
        link: '',
        hostMd5: '',
        title: '',
        description: '',
        cpdCategoryId: null,
        estimatedReadingTime: 0,
        publicationDate: new Date(),
        expiryDate: dateFnsCompat.addYears(new Date(), 1),
        cpdPoints: 1,
        status: contentStatus.Draft.value,
        publisherId: null,
        previewImageUrl: null,
        quizSize: 1,
        quizPassMark: 1,
        internalPdfFileName: null,
        internalContentTranscriptFileName: null,
        contentTranscript: null,
        contentTranscriptUrl: null,
        contentTranscriptFileName: null,
        isTasaCpd: false,
        additionalData: {
          accreditationDetails: []
        }
      },
      previewImage: null,
      croppedImageUrl: null,
      contentPdf: null,
      contentPdfUrl: null,
      contentOption: 'url',
      newTag: '',
      goals: [],
      tags: [],
      cpdCategorys: [],
      validation: {
        linkOrPdf: true,
        title: true,
        description: true,
        cpdCategoryId: true,
        contentType: true,
        estimatedReadingTime: true,
        publicationDate: true,
        expiryDate: true,
        cpdPoints: true,
        previewImage: true,
        status: true,
        aoaCpdPoints: true,
        aoaCpdPointsUnique: true,
        contentTranscript: true
      },
      showDeleteModal: false,
      showUpdateModal: false,
      showingCroppingModal: false,
      focusError: false,
      submitted: false,
      removedCurrentCpdCategorysCount: 0,
      transcriptDropError: null,
      transcriptDeleted: false
    };
  }

  componentDidMount() {
    const contentId = queryString.parse(this.props.location.search).contentId;
    if (contentId) {
      this.props.getContent(contentId);
      this.props.getContentQuestions(contentId);
    }

    if (this.props.publishers.length > 0) {
      this.setPublisher(fp.first(this.props.publishers).id);
    }
  }

  componentDidUpdate() {
    if (!this.props.business) {
      syncCpdCategoryWithGoals(
        {
          cpdCategorys: this.state.cpdCategorys,
          goals: this.state.goals
        },
        (updatedGoals) => this.setState({ goals: updatedGoals }),
        this.props.systemProfile
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      publishers,
      selectedContent: content,
      contentError,
      cpdCategorys
    } = nextProps;

    // Load existing Content into the state.
    if (
      content &&
      content.id &&
      (!this.state.content.id || this.state.content.id !== content.id)
    ) {
      this.setPublisher(content.publisherId);
      this.setState({
        content: {
          ...content,
          link: content.pdfContentFileName ? '' : content.link,
          publicationDate: dateFnsCompat.parse(content.publicationDate),
          expiryDate: dateFnsCompat.parse(content.expiryDate),
          additionalData: content.additionalData || { accreditationDetails: [] }
        },
        cpdCategorys: content.cpdCategorys,
        contentPdfUrl: content.pdfContentFileName ? content.link : null,
        contentOption: content.pdfContentFileName ? 'pdf' : 'url',
        tags: fp.map((t) => t.text)(content.tags),
        goals: content.goals,
        transcriptDeleted: false
      });
    } else if (publishers.length > 0) {
      this.setPublisher(fp.first(publishers).id);
    }

    if (
      cpdCategorys.length === 1 &&
      (!this.state.content.cpdCategoryId ||
        this.state.content.cpdCategoryId !== fp.first(cpdCategorys).id)
    ) {
      this.setState({
        content: {
          ...this.state.content,
          cpdCategoryId: fp.first(cpdCategorys).id
        }
      });
    }
    if (contentError) {
      this.setState({
        focusError: true
      });
    }
  }

  componentWillUnmount() {
    this.props.resetSelectedContent();
  }

  isTranscriptSupportedForType = (type) => {
    return transcriptSupportedContentTypes.includes(type);
  };

  onContentTypeChange = (event) => {
    const nextType = event && event.target ? event.target.value : event;

    this.setState((prev) => ({
      content: {
        ...prev.content,
        contentType: nextType
      },
      transcriptDropError: null,
      validation: {
        ...prev.validation,
        contentTranscript: true
      }
    }));
  };

  setPublisher(publisherId) {
    this.setState({
      content: {
        ...this.state.content,
        publisherId: parseInt(publisherId, 10)
      }
    });
  }

  removePreviewPdf() {
    this.setState({
      contentPdf: null
    });
  }

  removeSavedPdfFile() {
    this.setState((prevState, props) => ({
      content: {
        ...prevState.content,
        pdfContentFileName: null,
        internalPdfFileName: null
      },
      contentPdfUrl: null
    }));
  }

  removePreviewTranscript = () => {
    this.setState((prev) => ({
      content: {
        ...prev.content,
        contentTranscript: null,
        internalContentTranscriptFileName: null
      },
      transcriptDropError: null
    }));
  };

  removeSavedTranscriptFile = () => {
    this.setState((prev) => ({
      content: {
        ...prev.content,
        contentTranscriptFileName: null,
        internalContentTranscriptFileName: null,
        contentTranscriptUrl: null,
        contentTranscript: null
      },
      transcriptDropError: null,
      transcriptDeleted: true
    }));
  };

  removePreviewImage(event) {
    this.setState({
      previewImage: null,
      croppedImageUrl: null,
      showingCroppingModal: false
    });
  }

  removeSavedImage(event) {
    this.setState((prevState, props) => ({
      content: {
        ...prevState.content,
        previewImageUrl: null,
        previewImageFileName: null
      }
    }));
  }

  onImageCropped = (blob) => {
    this.setState(() => ({
      previewImage: blob,
      showingCroppingModal: false,
      croppedImageUrl: window.URL.createObjectURL(blob)
    }));
  };

  saveContent(
    {
      event = undefined,
      navigateToReviewQuestions = false,
      updateUsers = false
    } = {
      event: undefined,
      navigateToReviewQuestions: false,
      updateUsers: false
    }
  ) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.setState({ submitted: true });
    if (this.validateForm()) {
      const {
        content,
        contentOption,
        cpdCategorys,
        tags,
        goals,
        transcriptDeleted
      } = this.state;
      const contentExist = typeof content.id === 'number';
      let nextRoute = {};

      // Existing content, navigate to content questions page.
      if (contentExist && navigateToReviewQuestions) {
        nextRoute = {
          pathname: this.props.libraryRouteRoot.contentQuestion,
          search: `?${queryString.stringify({
            contentId: content.id,
            review: true
          })}`
        };
      }
      // Existing content, navigate to content page
      else if (contentExist) {
        nextRoute = {
          pathname: this.props.libraryRouteRoot.content
        };
      }
      // Create new content, navigate to completed content page
      else if (!contentExist && !navigateToReviewQuestions) {
        nextRoute = {
          pathname: this.props.libraryRouteRoot.completedContent
        };
      }
      // Create new content, then navigate to content questions page.
      else {
        nextRoute = {
          pathname: this.props.libraryRouteRoot.contentQuestion,
          contentIdParam: true
        };
      }

      const transcriptIsSupported = this.isTranscriptSupportedForType(
        content.contentType
      );
      const shouldSendTranscript =
        contentOption === 'url' && transcriptIsSupported;
      const shouldDeleteTranscript = transcriptDeleted || !shouldSendTranscript;

      this.props.saveContent(
        {
          contentData: {
            content: {
              ...content,
              ...(shouldDeleteTranscript
                ? {
                    contentTranscript: null,
                    internalContentTranscriptFileName: null,
                    contentTranscriptUrl: null,
                    contentTranscriptFileName: null
                  }
                : {}),
              link: contentOption === 'url' ? content.link : null,
              contentType:
                contentOption === 'url'
                  ? content.contentType
                  : contentType.Article,
              publicationDate: dateFnsCompat.format(content.publicationDate),
              expiryDate: dateFnsCompat.format(content.expiryDate)
            },
            cpdCategorys: cpdCategorys,
            tags: tags,
            goals: goals,
            updateUsers
          },
          files: [
            {
              key: 'pdfContent',
              value: contentOption === 'pdf' ? this.state.contentPdf : null
            },
            { key: 'previewImage', value: this.state.previewImage },
            {
              key: 'contentTranscript',
              value: shouldSendTranscript
                ? this.state.content.contentTranscript
                : null
            }
          ]
        },
        nextRoute
      );
    } else if (this.formRef) {
      handleInvalidForm(this.formRef);
    }
  }

  validateForm() {
    const { content, contentPdf, cpdCategorys } = this.state;

    const validation = {
      linkOrPdf:
        content.link.trim() !== '' || contentPdf || content.pdfContentFileName, // TODO: Enforce valid URL?
      title: content.title.trim() !== '',
      description: content.description.trim() !== '',
      contentType:
        fp.includes(content.contentType)(fp.values(contentType)) ||
        contentPdf ||
        content.pdfContentFileName,
      estimatedReadingTime:
        typeof content.estimatedReadingTime === 'number' &&
        content.estimatedReadingTime >= 0,
      publicationDate: dateFnsCompat.isPast(
        dateFnsCompat.subWeeks(content.publicationDate, 2)
      ),
      expiryDate: dateFnsCompat.isFuture(content.expiryDate),
      publisherId: content.publisherId !== null || this.props.business,
      previewImage: true,
      status: content.status,
      aoaCpdPoints:
        (this.props.business || fp.size(cpdCategorys) > 0) &&
        fp.every(
          (aoaCpdPoint) => aoaCpdPoint.cpdCategoryId && aoaCpdPoint.points !== 0
        )(cpdCategorys),
      aoaCpdPointsUnique:
        fp.size(fp.uniqBy('cpdCategoryId')(cpdCategorys)) ===
          fp.size(cpdCategorys) &&
        (this.props.business || fp.size(cpdCategorys) > 0),
      accreditationDetails: content.additionalData.accreditationDetails
        .map((detail) => {
          return Object.entries(detail)
            .map(([key, value]) => this.validateAccreditationDetail(key, value))
            .every((error) => error === undefined);
        })
        .every((validation) => validation)
    };

    this.setState({ validation: validation });

    return fp.all(fp.identity)(validation);
  }

  validateAccreditationDetail(field, value) {
    // Accreditation name cannot be empty.
    if (field === 'name' && !isNonEmptyString(value)) {
      return 'Accreditation Number is required';
    }

    // Accreditation number cannot be empty.
    if (field === 'number' && !isNonEmptyString(value)) {
      return 'Accreditation Number is required';
    }

    // Accreditation number can only includes letters and numbers.
    if (field === 'number' && !/^[A-Za-z0-9]*$/.test(value)) {
      return 'Only letters and numbers are allowed';
    }

    // Accreditation number must greater than 0.
    if (field === 'points' && (!isNonEmptyNumber(value) || value <= 0)) {
      return 'Must be more than 0';
    }
  }

  onPublicationDateChange(dateFunc, value) {
    const { content } = this.state;

    this.setState({
      content: {
        ...content,
        publicationDate: dateFunc(content.publicationDate, value)
      }
    });
  }

  onExpiryDateChange(dateFunc, value) {
    const { content } = this.state;

    this.setState({
      content: {
        ...content,
        expiryDate: dateFunc(content.expiryDate, value)
      }
    });
  }

  onFormChange({ name, value }) {
    this.setState({
      content: {
        ...this.state.content,
        [name]: value
      }
    });
  }

  onReadingTimeChange(event) {
    const nextContent = Object.assign({}, this.state.content);
    nextContent.estimatedReadingTime = parseInt(event.value, 10) || 0;
    this.setState({ content: nextContent });
  }

  onIsTasaCpdChange(event) {
    const nextContent = Object.assign({}, this.state.content);
    nextContent.isTasaCpd = event.target.checked;
    this.setState({ content: nextContent });
  }

  onContentCpdCategoryChange(index, cpdCategoryId) {
    const currentCpdCategorys = this.state.cpdCategorys;
    const nextCpdCategorys = noCapMap((contentCpdCategory, cid) =>
      cid === index
        ? {
            ...contentCpdCategory,
            cpdCategoryId
          }
        : contentCpdCategory
    )(currentCpdCategorys);
    this.setState({
      cpdCategorys: nextCpdCategorys
    });
  }

  // Update the industry with a not in form (not duplicated) category.
  // Do nothing when all the categories of target industry are added to form.
  onContentIndustryChange(targetCpdCategoryType, index, industryId) {
    const currentCpdCategorys = this.state.cpdCategorys;
    const industriesAvailable = this.getIndustriesWithAvailableCategories(
      targetCpdCategoryType
    );
    const industrySelected = fp.find(
      ({ industry }) => industry.id === industryId
    )(industriesAvailable);

    if (industrySelected !== undefined) {
      const defaultCpdCategory = fp.flow(
        fp.get('cpdCategorys'),
        fp.first
      )(industrySelected);
      const nextCpdCategorys = noCapMap((contentCpdCategory, cid) =>
        cid === index
          ? {
              ...contentCpdCategory,
              industryId,
              cpdCategoryId: defaultCpdCategory.id
            }
          : contentCpdCategory
      )(currentCpdCategorys);
      this.setState({
        cpdCategorys: nextCpdCategorys
      });
    }
  }

  setCpdPoints(index, points) {
    const currentCpdCategorys = this.state.cpdCategorys;
    const nextCpdCategorys = noCapMap((contentCpdCategory, cid) =>
      cid === index
        ? {
            ...contentCpdCategory,
            points
          }
        : contentCpdCategory
    )(currentCpdCategorys);
    this.setState({
      cpdCategorys: nextCpdCategorys
    });
  }

  setAccreditationDetail(index, field, value) {
    const currentAccreditationDetails =
      this.state.content.additionalData.accreditationDetails;
    const nextAccreditationDetails = noCapMap((accreditationDetail, cid) =>
      cid === index
        ? {
            ...accreditationDetail,
            [field]: value
          }
        : accreditationDetail
    )(currentAccreditationDetails);

    this.setState({
      content: {
        ...this.state.content,
        additionalData: {
          ...this.state.content.additionalData,
          accreditationDetails: nextAccreditationDetails
        }
      }
    });
  }

  removeContentCpdCategory(index) {
    const currentCpdCategorys = this.state.cpdCategorys;
    const nextCpdCategorys = noCapFilter(
      (contentCpdCategory, cid) => cid !== index
    )(currentCpdCategorys);

    this.setState({
      cpdCategorys: nextCpdCategorys,
      removedCurrentCpdCategorysCount: this.isOriginalCpdCategoryRow(index)
        ? this.state.removedCurrentCpdCategorysCount + 1
        : this.state.removedCurrentCpdCategorysCount
    });
  }

  removeContentAccreditationDetail(index) {
    const currentAccreditationDetails =
      this.state.content.additionalData.accreditationDetails;
    const nextAccreditationDetails = noCapFilter((_, cid) => cid !== index)(
      currentAccreditationDetails
    );

    this.setState({
      content: {
        ...this.state.content,
        additionalData: {
          ...this.state.content.additionalData,
          accreditationDetails: nextAccreditationDetails
        }
      }
    });
  }

  addAvailableAccreditationDetail() {
    const currentAccreditationDetails =
      this.state.content.additionalData.accreditationDetails;
    const toAddAccreditationNameKey = fp.flow(
      fp.keys,
      fp.filter(
        (key) =>
          !fp.contains(accreditationNames[key])(
            fp.map('name')(currentAccreditationDetails)
          ) && key !== 'Other'
      ),
      fp.first
    )(accreditationNames);
    const toAddAccreditationName =
      accreditationNames[toAddAccreditationNameKey];
    const toAddAccreditationDetail = {
      name: toAddAccreditationName || '',
      points: 0,
      number: ''
    };

    this.setState({
      content: {
        ...this.state.content,
        additionalData: {
          ...this.state.content.additionalData,
          accreditationDetails: [
            ...currentAccreditationDetails,
            toAddAccreditationDetail
          ]
        }
      }
    });
  }

  // Get industries with target cpd category type (parent or children)
  // and filter out all categories that already included in form (this.state.cpdCategorys).
  getIndustriesWithAvailableCategories(targetCpdCategoryType) {
    const isCore =
      targetCpdCategoryType === cpdCategoryType.core ? true : false;
    const currentCpdCategories = this.state.cpdCategorys;
    const industriesWithAvailableCategories = fp.flow(
      fp.map((industry) => {
        const targetCategories = fp.flow(
          // Get target type of cpd categories
          fp.filter((category) =>
            isCore
              ? category.categoryType === cpdCategoryType.core
              : category.categoryType === cpdCategoryType.sub
          ),
          // Filter out the categories that already in form
          fp.filter(
            (category) =>
              !currentCpdCategories.some(
                (currentCategory) =>
                  currentCategory.industryId === industry.industry.id &&
                  currentCategory.cpdCategoryId === category.id
              )
          )
        )(industry.cpdCategorys);
        return {
          ...industry,
          cpdCategorys: targetCategories
        };
      }),
      fp.filter((industry) => industry.cpdCategorys.length > 0)
    )(this.props.industriesAvailable);
    return industriesWithAvailableCategories;
  }

  // Add a not duplicated category into the form.
  // Do nothing when all the available categories are added to form.
  addAvailableCpdCategory(targetCpdCategoryType) {
    const currentCpdCategorys = this.state.cpdCategorys;
    const industriesWithAvailableCategories =
      this.getIndustriesWithAvailableCategories(targetCpdCategoryType);
    if (industriesWithAvailableCategories.length > 0) {
      const toAddIndustry = fp.first(industriesWithAvailableCategories);
      const toAddNewCpdCategory = fp.flow(
        fp.get('cpdCategorys'),
        fp.first
      )(toAddIndustry);
      const nextCpdCategorys = currentCpdCategorys.concat([
        {
          industryId: fp.get('industry.id')(toAddIndustry),
          cpdCategoryId: toAddNewCpdCategory.id,
          points: 0
        }
      ]);
      this.setState({
        cpdCategorys: nextCpdCategorys
      });
    }
  }

  addCpdCategory() {
    const currentCpdCategorys = this.state.cpdCategorys;
    const defaultIndustry = fp.first(this.props.industriesAvailable);
    const defaultNewCpdCategory = fp.flow(
      fp.get('cpdCategorys'),
      fp.first
    )(defaultIndustry);
    const nextCpdCategorys = currentCpdCategorys.concat([
      {
        industryId: fp.get('industry.id')(defaultIndustry),
        cpdCategoryId: defaultNewCpdCategory.id,
        points: 0
      }
    ]);
    this.setState({
      cpdCategorys: nextCpdCategorys
    });
  }

  onContentStatusChange(event) {
    const nextContent = Object.assign({}, this.state.content, {
      status: event.target.value
    });
    this.setState({ content: nextContent });
  }

  onContentGoalChange(event) {
    const selectedGoalId = parseInt(event.target.value, 10);
    const isGoalAlreadySelected = fp.includes(selectedGoalId)(this.state.goals);
    const nextGoals = isGoalAlreadySelected
      ? fp.filter((progressGoalId) => progressGoalId !== selectedGoalId)(
          this.state.goals
        )
      : this.state.goals.concat(selectedGoalId);
    this.setState({ goals: nextGoals });
  }

  onAddTagKeyPress(event) {
    if ((event.key && event.key === 'Enter') || event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();

      const newTag = event.target.value.trim();

      if (newTag !== '' && !fp.includes(newTag, this.state.tags)) {
        this.setState({ tags: this.state.tags.concat(newTag), newTag: '' });
      }
    }
  }

  onPreviewImageDrop = (acceptedFiles, rejectedFiles) => {
    const acceptedFile = fp.first(acceptedFiles);
    const rejectedFile = fp.first(rejectedFiles);

    if (acceptedFile) {
      this.setState({
        previewImage: acceptedFile,
        showingCroppingModal: true,
        validation: { ...this.state.validation, previewImage: true }
      });
    }

    if (rejectedFile) {
      this.setState({
        validation: { ...this.state.validation, previewImage: false }
      });
    }
  };

  onPdfDrop(acceptedFiles, rejectedFiles) {
    const acceptedFile = fp.first(acceptedFiles);
    const rejectedFile = fp.first(rejectedFiles);

    if (acceptedFile) {
      this.setState({
        contentPdf: acceptedFile,
        content: {
          ...this.state.content,
          internalPdfFileName: acceptedFile.name
        },
        validation: { ...this.state.validation, linkOrPdf: true }
      });
    }

    if (rejectedFile) {
      this.setState({
        contentPdf: null,
        content: { ...this.state.content, internalPdfFileName: null },
        validation: { ...this.state.validation, linkOrPdf: false }
      });
    }
  }

  onTranscriptDrop = (acceptedFiles, rejectedFiles) => {
    const acceptedFile = fp.first(acceptedFiles);
    const rejectedFile = fp.first(rejectedFiles);

    if (acceptedFile) {
      this.setState((prev) => ({
        content: {
          ...prev.content,
          contentTranscript: acceptedFile,
          internalContentTranscriptFileName: acceptedFile.name
        },
        transcriptDropError: null,
        transcriptDeleted: false
      }));
      return;
    }

    if (rejectedFile) {
      this.setState({
        transcriptDropError: 'Only PDF files are accepted.'
      });
    }
  };

  resetValidation() {
    this.setState({
      validation: {
        linkOrPdf: true,
        title: true,
        description: true,
        cpdCategoryId: true,
        contentType: true,
        estimatedReadingTime: true,
        publicationDate: true,
        expiryDate: true,
        cpdPoints: true,
        previewImage: true,
        status: true,
        aoaCpdPoints: true,
        aoaCpdPointsUnique: true,
        contentTranscript: true
      }
    });
  }

  onContentOptionChange(event) {
    const nextOption = event.target.value;

    this.setState((prev) => ({
      contentOption: nextOption,
      transcriptDropError: null
    }));

    this.resetValidation();
  }

  removeTag(tag) {
    this.setState({ tags: fp.remove((x) => x === tag)(this.state.tags) });
  }

  isLoading() {
    return this.props.isFetchingCpdCategorys;
  }

  cpdCategoryProps(cpdCategory) {
    return {
      key: cpdCategory.id,
      value: cpdCategory.id,
      label: <span>{cpdCategory.name}</span>,
      checked: this.state.content.cpdCategoryId === cpdCategory.id,
      validation: this.state.validation.cpdCategoryId ? null : true
    };
  }

  contentTypeProps(type) {
    return {
      key: type,
      value: type,
      label: <span>{fp.startCase(type)}</span>,
      checked: this.state.content.contentType === type,
      validation: this.state.validation.contentType ? null : true
    };
  }

  contentStatusProps(status) {
    return {
      key: status.value,
      value: status.value,
      label: <span>{status.label}</span>,
      checked: this.state.content.status === status.value,
      validation: this.state.validation.status ? null : true
    };
  }

  contentGoalProps(goal) {
    return {
      key: goal.id,
      value: goal.id,
      label: <span>{goal.name}</span>,
      checked: fp.includes(goal.id)(this.state.goals)
    };
  }

  confirmDelete() {
    this.props.deleteContent(this.state.content.id);
    this.closeDeleteModal();
  }

  closeDeleteModal() {
    this.setState({
      showDeleteModal: false
    });
  }

  deleteContent() {
    this.setState({
      showDeleteModal: true
    });
  }

  stopFocusError() {
    this.setState({
      focusError: false
    });
  }

  updateContent(cpdCategorysChanged) {
    this.setState({
      showUpdateModal: true
    });
    if (cpdCategorysChanged) {
      this.props.getContentPassedUserEmails(this.state.content.id);
    }
  }

  exportCompletedUsers() {
    const csvColumns = ['Email'];
    const csvRows = this.props.contentPassedUserEmails.map((email) => [email]);
    downloadBlobStreamFile(
      writeDataToCsvStream(
        getCsvStream({
          header: true,
          columns: csvColumns
        }),
        csvRows
      ).pipe(getBlobStream()),
      `${this.state.content.title} user completions.csv`
    );
  }

  hasCpdCategorysChanged = () => {
    const updatedCpdCategorys =
      (this.props.selectedContent && this.props.selectedContent.cpdCategorys) ||
      [];
    const currentCpdCategorys = this.state.cpdCategorys || [];

    if (updatedCpdCategorys.length !== currentCpdCategorys.length) return true;
    const sortFn = (a, b) =>
      a.industryId - b.industryId ||
      a.cpdCategoryId - b.cpdCategoryId ||
      a.points - b.points;
    const sorted1 = [...updatedCpdCategorys].sort(sortFn);
    const sorted2 = [...currentCpdCategorys].sort(sortFn);
    return JSON.stringify(sorted1) !== JSON.stringify(sorted2);
  };

  /**
   * Determines whether a CPD category row at the given index
   * was part of the original rows present in the content.
   *
   * @param index - The index of the CPD category row to check.
   * @returns `true` if the row is part of the original content, otherwise `false`.
   */
  isOriginalCpdCategoryRow = (index) => {
    const currentCpdCategorysCount = (
      (this.props.selectedContent && this.props.selectedContent.cpdCategorys) ||
      []
    ).length;
    const cpdCategoryIsCurrent =
      index <=
      currentCpdCategorysCount - 1 - this.state.removedCurrentCpdCategorysCount;
    return cpdCategoryIsCurrent;
  };

  closeUpdateContent() {
    this.setState({
      showUpdateModal: false
    });
  }

  render() {
    const { focusError } = this.state;
    const { isFetchingContent } = this.props;

    const coreCategoriesWithIndustryId = this.props.industriesAvailable.flatMap(
      (industryWithCategories) => {
        const industryId = industryWithCategories.industry.id;
        const coreCategories = industryWithCategories.cpdCategorys.filter(
          (category) => category.categoryType === cpdCategoryType.core
        );
        return coreCategories.map((category) => ({
          industryId,
          cpdCategoryId: category.id
        }));
      }
    );
    const currentCoreCpdCategories = this.state.cpdCategorys.filter(
      (category) =>
        coreCategoriesWithIndustryId.some(
          (parentCategory) =>
            parentCategory.industryId === category.industryId &&
            parentCategory.cpdCategoryId === category.cpdCategoryId
        )
    );

    const subCategoriesWithIndustryId = this.props.industriesAvailable.flatMap(
      (industryWithCategories) => {
        const industryId = industryWithCategories.industry.id;
        const subCategories = industryWithCategories.cpdCategorys.filter(
          (category) => category.categoryType === cpdCategoryType.sub
        );
        return subCategories.map((category) => ({
          industryId,
          cpdCategoryId: category.id
        }));
      }
    );
    const currentSubCpdCategories = this.state.cpdCategorys.filter((category) =>
      subCategoriesWithIndustryId.some(
        (parentCategory) =>
          parentCategory.industryId === category.industryId &&
          parentCategory.cpdCategoryId === category.cpdCategoryId
      )
    );

    const industriesWithAvailableCoreCategories =
      this.getIndustriesWithAvailableCategories(cpdCategoryType.core);

    const industriesWithAvailableSubCategories =
      this.getIndustriesWithAvailableCategories(cpdCategoryType.sub);

    const currentAccreditationDetails =
      this.state.content.additionalData.accreditationDetails;

    const cpdCategorysChanged = this.hasCpdCategorysChanged();

    const hasPassedUsers = this.props.contentPassedUserEmails.length > 0;
    const shouldHideActionButton = !cpdCategorysChanged || !hasPassedUsers;

    const hasNewTranscript = !!this.state.content.contentTranscript;
    const hasSavedTranscript = !!this.state.content.contentTranscriptUrl;
    const hasTranscript = hasNewTranscript || hasSavedTranscript;

    const transcriptHref = hasNewTranscript
      ? this.state.content.contentTranscript.preview
      : toSafeExternalUrl(
          he.decode(this.state.content.contentTranscriptUrl || '')
        );

    const transcriptLabel = hasNewTranscript
      ? this.state.content.contentTranscript.name
      : this.state.content.internalContentTranscriptFileName || 'Transcript';
    const actions = [
      {
        onConfirmAction: () => {
          this.saveContent();
          this.closeUpdateContent();
        },
        actionLabel: 'Update for future users only'
      },
      {
        onConfirmAction: (e) => {
          this.saveContent({ updateUsers: true });
          this.closeUpdateContent();
        },
        hideActionButton: shouldHideActionButton,
        checkBoxText:
          'Please confirm if you would also like to update the points of users who have already completed this content.',
        actionLabel: 'Update for all users (future and completed)'
      },
      {
        onConfirmAction: () => this.exportCompletedUsers(),
        hideActionButton: shouldHideActionButton,
        actionLabel: 'Export users to CSV',
        bsStyle: 'plain'
      }
    ];

    const transcriptIsSupported = transcriptSupportedContentTypes.includes(
      this.state.content.contentType
    );

    return (
      <section id='section--add-content-questions'>
        <Grid>
          <h1 className='text-center'>Content Details</h1>
          <Row className='md-gutter'>
            <Col xs={12} md={8} mdOffset={2} className='boxed text-left'>
              {this.isLoading() ? (
                <Loading />
              ) : (
                <form
                  ref={(form) => {
                    this.formRef = form;
                  }}
                  noValidate
                >
                  {
                    // Only show Publisher selection when the loaded Publishers are more than 1.
                    this.props.publishers.length > 1 &&
                    this.props.choosePublisher ? (
                      <fieldset>
                        <FormField
                          id='publisher-id'
                          label='Publisher'
                          type='select-item'
                        >
                          <select
                            id='publisher-id'
                            value={this.state.content.publisherId || ''}
                            required
                            onChange={(e) => this.setPublisher(e.target.value)}
                          >
                            {this.state.content.publisherId ? null : (
                              <option value={''}></option>
                            )}
                            {fp.compose(
                              fp.map(({ id, name }) => (
                                <option value={id} key={id}>
                                  {he.decode(name)}
                                </option>
                              )),
                              fp.sortBy(({ name }) => fp.lowerCase(name))
                            )(this.props.publishers)}
                          </select>
                        </FormField>
                      </fieldset>
                    ) : null
                  }
                  {this.props.contentError ? (
                    <ServerError
                      innerRef={(messageRef) => {
                        if (messageRef && focusError) {
                          focusElement(messageRef);
                          this.stopFocusError();
                        }
                      }}
                      error={this.props.contentError}
                      hideSupport
                    />
                  ) : null}
                  {this.state.content.publisherId || this.props.business ? (
                    <div>
                      <ControlGroup
                        id='content-option'
                        control='radio'
                        type='pill'
                        label={null}
                        onChange={(e) => this.onContentOptionChange(e)}
                      >
                        <ControlOption
                          value='url'
                          checked={this.state.contentOption === 'url'}
                          type={'radio'}
                          label={<span>URL</span>}
                        />
                        <ControlOption
                          value='pdf'
                          checked={this.state.contentOption === 'pdf'}
                          type={'radio'}
                          label={<span>PDF</span>}
                        />
                      </ControlGroup>
                      <fieldset>
                        {this.state.contentOption === 'url' ? (
                          <InputFormField
                            id='link'
                            label='Content URL'
                            required
                            validation={
                              this.state.validation.linkOrPdf
                                ? null
                                : 'Content URL is required.'
                            }
                            value={he.decode(this.state.content.link)}
                            onChange={(e) =>
                              this.onFormChange({
                                name: e.target.name,
                                value: he.encode(e.target.value)
                              })
                            }
                          />
                        ) : null}
                        {this.state.contentOption === 'pdf' &&
                        this.state.contentPdfUrl &&
                        !this.state.contentPdf ? (
                          <Row className='xs-gutter'>
                            <Col xs={10} xsOffset={1}>
                              <a
                                href={
                                  toSafeExternalUrl(
                                    he.decode(this.state.contentPdfUrl)
                                  ) || undefined
                                }
                                className='flex-center linkBox'
                                target='_blank'
                              >
                                {this.state.content.internalPdfFileName}
                              </a>
                            </Col>
                            <Col xs={1}>
                              <Button
                                bsStyle='plain'
                                className='p-0 existing-file-remove pull-right'
                                onClick={() => this.removeSavedPdfFile()}
                              >
                                <Icon icon='close-thick' />
                              </Button>
                            </Col>
                          </Row>
                        ) : null}
                        {this.state.contentOption === 'pdf' &&
                        this.state.contentPdf ? (
                          <Row className='xs-gutter'>
                            <Col xs={10} xsOffset={1}>
                              <a
                                href={this.state.contentPdf.preview}
                                className='flex-center linkBox'
                                target='_blank'
                              >
                                {this.state.contentPdf.name}
                              </a>
                            </Col>
                            <Col xs={1}>
                              <Button
                                bsStyle='plain'
                                className='p-0 existing-file-remove pull-right'
                                onClick={() => this.removePreviewPdf()}
                              >
                                <Icon icon='close-thick' />
                              </Button>
                            </Col>
                          </Row>
                        ) : null}
                        {this.state.contentOption === 'pdf' ? (
                          <FileUploadFormField
                            styleName='file-6'
                            accept='application/pdf'
                            multiple={false}
                            onFileDrop={this.onPdfDrop.bind(this)}
                            file={this.state.contentPdf}
                            maxSize={this.props.config.maxContentPdfSizeBytes}
                            validationMessage={
                              this.state.validation.linkOrPdf
                                ? null
                                : 'Please select pdf file (max file size ' +
                                  prettyBytes(
                                    this.props.config.maxContentPdfSizeBytes
                                  ) +
                                  ').'
                            }
                            dropLabel='Upload PDF file'
                          />
                        ) : null}
                        <h2>Content Preview</h2>
                        <iframe
                          sandbox={
                            this.state.contentOption === 'pdf'
                              ? undefined
                              : 'allow-same-origin allow-scripts allow-popups allow-forms'
                          }
                          className='preview-frame'
                          title='content-preview'
                          src={
                            this.state.contentOption === 'pdf'
                              ? fp.get('preview')(this.state.contentPdf)
                                ? fp.get('preview')(this.state.contentPdf)
                                : this.state.contentPdfUrl
                                  ? toSafeExternalUrl(
                                      he.decode(this.state.contentPdfUrl)
                                    ) || 'about:blank'
                                  : 'about:blank'
                              : toSafeExternalUrl(
                                  he.decode(this.state.content.link)
                                ) || 'about:blank'
                          }
                        ></iframe>
                        <InputFormField
                          id='title'
                          label='Content title'
                          required
                          validation={
                            this.state.validation.title
                              ? null
                              : 'Content title is required.'
                          }
                          value={he.decode(this.state.content.title)}
                          onChange={(e) =>
                            this.onFormChange({
                              name: e.target.name,
                              value: he.encode(e.target.value)
                            })
                          }
                        />
                        <TextAreaFormField
                          id='description'
                          label='Description of content'
                          required
                          validation={
                            this.state.validation.description
                              ? null
                              : 'Description of content is required.'
                          }
                          value={he.decode(this.state.content.description)}
                          onChange={(e) =>
                            this.onFormChange({
                              name: e.target.name,
                              value: he.encode(e.target.value)
                            })
                          }
                        />
                        <FormItem>
                          <label htmlFor='estimated-reading-time'>
                            Estimated Reading Time - (mins)
                          </label>
                        </FormItem>
                        <NumberFormField
                          id='estimated-reading-time'
                          label={null}
                          required
                          validation={
                            this.state.validation.estimatedReadingTime
                              ? null
                              : 'Estimated reading time is required.'
                          }
                          value={this.state.content.estimatedReadingTime}
                          onChange={(e) => this.onReadingTimeChange(e)}
                          min={0}
                        />
                      </fieldset>
                      <fieldset>
                        <Row>
                          <Col xs={9}>
                            <h2 className='strong'>Accreditation Details</h2>
                          </Col>
                          {currentAccreditationDetails.map(
                            ({ name, number, points }, index) => {
                              const nameKey =
                                _.invert(accreditationNames)[name] || 'Other';
                              return (
                                <Col xs={12} key={index}>
                                  <Row className='xs-gutter'>
                                    <Col xs={6}>
                                      <SelectFormField
                                        formGroupProps={{
                                          className: 'clearfix'
                                        }}
                                        id={`accreditation-${index}`}
                                        name={`additionalData.accreditationDetails[${index}].name`}
                                        label='Accreditation'
                                        onChange={(e) => {
                                          if (e.target.value === 'Other') {
                                            this.setAccreditationDetail(
                                              index,
                                              'name',
                                              ''
                                            );
                                          } else {
                                            this.setAccreditationDetail(
                                              index,
                                              'name',
                                              accreditationNames[e.target.value]
                                            );
                                          }
                                        }}
                                        emptyOption={false}
                                        required
                                        value={nameKey}
                                      >
                                        {fp.flow(
                                          fp.keys,
                                          fp.filter(
                                            (key) =>
                                              !fp.contains(
                                                accreditationNames[key]
                                              )(
                                                fp.map('name')(
                                                  currentAccreditationDetails
                                                )
                                              ) || key === nameKey
                                          ),
                                          fp.map((key) => (
                                            <option key={key} value={key}>
                                              {he.decode(
                                                accreditationNames[key]
                                              )}
                                            </option>
                                          ))
                                        )(accreditationNames)}
                                      </SelectFormField>
                                    </Col>
                                    {nameKey === 'Other' && (
                                      <Col xs={6}>
                                        <InputFormField
                                          id={`accreditation-name-input-${index}`}
                                          label='Name'
                                          name={`additionalData.accreditationDetails[${index}].name`}
                                          required={true}
                                          value={name}
                                          onChange={(e) =>
                                            this.setAccreditationDetail(
                                              index,
                                              'name',
                                              e.target.value
                                            )
                                          }
                                          validation={
                                            this.state.submitted
                                              ? this.validateAccreditationDetail(
                                                  'name',
                                                  currentAccreditationDetails[
                                                    index
                                                  ].name
                                                )
                                              : undefined
                                          }
                                        />
                                      </Col>
                                    )}
                                  </Row>
                                  <Row className='xs-gutter'>
                                    <Col xs={8}>
                                      <InputFormField
                                        id={`accreditation-number-input-${index}`}
                                        label='Number'
                                        name={`additionalData.accreditationDetails[${index}].number`}
                                        required={true}
                                        value={number}
                                        onChange={(e) =>
                                          this.setAccreditationDetail(
                                            index,
                                            'number',
                                            e.target.value
                                          )
                                        }
                                        validation={
                                          this.state.submitted
                                            ? this.validateAccreditationDetail(
                                                'number',
                                                currentAccreditationDetails[
                                                  index
                                                ].number
                                              )
                                            : undefined
                                        }
                                      />
                                    </Col>
                                    <Col xs={2}>
                                      <NumberFormField
                                        {...{
                                          id: `accreditation-points-${index}`,
                                          label: 'Hours',
                                          min: 0,
                                          step: 0.25,
                                          onChange: (e) =>
                                            this.setAccreditationDetail(
                                              index,
                                              'points',
                                              e.value
                                            ),
                                          required: true,
                                          value: points,
                                          validation: this.state.submitted
                                            ? this.validateAccreditationDetail(
                                                'points',
                                                currentAccreditationDetails[
                                                  index
                                                ].points
                                              )
                                            : undefined
                                        }}
                                      />
                                    </Col>
                                    <Col xs={1}>
                                      <Button
                                        bsStyle='plain'
                                        className='large area-of-advice-remove pull-right'
                                        onClick={() =>
                                          this.removeContentAccreditationDetail(
                                            index
                                          )
                                        }
                                      >
                                        <Icon icon='close-thick' />
                                      </Button>
                                    </Col>
                                  </Row>
                                </Col>
                              );
                            }
                          )}
                          <Col xs={12} className='flex-center'>
                            <Button
                              onClick={() =>
                                this.addAvailableAccreditationDetail()
                              }
                              className='mt-3'
                              style={{ marginBottom: 30 }}
                            >
                              <Icon icon='add-large' /> Add Accreditation
                              Details
                            </Button>
                          </Col>
                        </Row>
                      </fieldset>
                      {this.state.contentOption === 'url' ? (
                        <fieldset>
                          <ControlGroup
                            id='content-type'
                            control='radio'
                            type='styled'
                            label={<h2>Content Type</h2>}
                            validation={
                              this.state.validation.contentType
                                ? null
                                : 'Content type is required.'
                            }
                            onChange={this.onContentTypeChange}
                            colProps={{ xs: 12, sm: 6 }}
                          >
                            {fp.map((type) => (
                              <ControlOption {...this.contentTypeProps(type)} />
                            ))(contentType)}
                          </ControlGroup>
                        </fieldset>
                      ) : null}
                      {this.state.contentOption === 'url' &&
                      transcriptIsSupported ? (
                        <fieldset>
                          <FormItem className='has-error'>
                            <h2>Content Transcript</h2>
                          </FormItem>

                          {hasTranscript ? (
                            <Row className='xs-gutter'>
                              <Col xs={10} xsOffset={1}>
                                <a
                                  href={transcriptHref}
                                  className='flex-center linkBox'
                                  target='_blank'
                                  rel='noopener noreferrer'
                                >
                                  {transcriptLabel}
                                </a>
                              </Col>
                              <Col xs={1}>
                                <Button
                                  bsStyle='plain'
                                  className='p-0 existing-file-remove pull-right'
                                  onClick={() =>
                                    hasNewTranscript
                                      ? this.removePreviewTranscript()
                                      : this.removeSavedTranscriptFile()
                                  }
                                >
                                  <Icon icon='close-thick' />
                                </Button>
                              </Col>
                            </Row>
                          ) : (
                            <FileUploadFormField
                              styleName='file-6'
                              accept='application/pdf'
                              multiple={false}
                              onFileDrop={this.onTranscriptDrop}
                              file={this.state.content.contentTranscript}
                              maxSize={this.props.config.maxContentPdfSizeBytes}
                              validationMessage={
                                this.state.transcriptDropError || null
                              }
                              dropLabel='Upload Transcript PDF File'
                            />
                          )}
                        </fieldset>
                      ) : null}
                      <fieldset>
                        <FormItem className='has-error'>
                          <h2>Publication Date</h2>{' '}
                          {this.state.validation.publicationDate ? null : (
                            <span>(Publication date is invalid.)</span>
                          )}
                        </FormItem>
                        <Row>
                          <Col xs={12} md={4}>
                            <FormField
                              id='publication-date-day'
                              label='Day'
                              type='select-item'
                              required
                            >
                              <select
                                id='publication-date-day'
                                value={dateFnsCompat.getDate(
                                  this.state.content.publicationDate
                                )}
                                required
                                aria-invalid={
                                  this.state.validation.publicationDate
                                    ? 'false'
                                    : 'true'
                                }
                                onChange={(e) =>
                                  this.onPublicationDateChange(
                                    dateFnsCompat.setDate,
                                    e.target.value
                                  )
                                }
                              >
                                {fp.map((day) => (
                                  <option key={day} value={day}>
                                    {day}
                                  </option>
                                ))(
                                  fp.times((x) => x + 1)(
                                    dateFnsCompat.getDaysInMonth(
                                      this.state.content.publicationDate
                                    )
                                  )
                                )}
                              </select>
                            </FormField>
                          </Col>
                          <Col xs={12} md={4}>
                            <FormField
                              id='publication-date-month'
                              label='Month'
                              type='select-item'
                              required
                            >
                              <select
                                id='publication-date-month'
                                value={dateFnsCompat.getMonth(
                                  this.state.content.publicationDate
                                )}
                                required
                                aria-invalid={
                                  this.state.validation.publicationDate
                                    ? 'false'
                                    : 'true'
                                }
                                onChange={(e) =>
                                  this.onPublicationDateChange(
                                    dateFnsCompat.setMonth,
                                    e.target.value
                                  )
                                }
                              >
                                {noCapMap((month, index) => (
                                  <option key={index} value={index}>
                                    {month}
                                  </option>
                                ))(fp.values(months))}
                              </select>
                            </FormField>
                          </Col>
                          <Col xs={12} md={4}>
                            <FormField
                              id='publication-date-year'
                              label='Year'
                              type='select-item'
                              required
                            >
                              <select
                                id='publication-date-year'
                                value={dateFnsCompat.getYear(
                                  this.state.content.publicationDate
                                )}
                                required
                                aria-invalid={
                                  this.state.validation.publicationDate
                                    ? 'false'
                                    : 'true'
                                }
                                onChange={(e) =>
                                  this.onPublicationDateChange(
                                    dateFnsCompat.setYear,
                                    e.target.value
                                  )
                                }
                              >
                                {fp.map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                ))(
                                  fp.range(2010)(
                                    dateFnsCompat.getYear(
                                      dateFnsCompat.addYears(new Date(), 2)
                                    )
                                  )
                                )}
                              </select>
                            </FormField>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} md={12}>
                            <FormGroup
                              id='publication-date'
                              validation={
                                this.state.validation.publicationDate
                                  ? null
                                  : 'Publication date cannot be set beyond two weeks in the future.'
                              }
                            ></FormGroup>
                          </Col>
                        </Row>
                      </fieldset>
                      <fieldset>
                        <FormItem className='has-error'>
                          <h2>Expiry Date</h2>{' '}
                          {this.state.validation.expiryDate ? null : (
                            <span>(Expiry date is invalid.)</span>
                          )}
                        </FormItem>
                        <Row>
                          <Col xs={12} md={4}>
                            <FormField
                              id='expiry-date-day'
                              label='Day'
                              type='select-item'
                              required
                            >
                              <select
                                id='expiry-date-day'
                                value={dateFnsCompat.getDate(
                                  this.state.content.expiryDate
                                )}
                                required
                                aria-invalid={
                                  this.state.validation.expiryDate
                                    ? 'false'
                                    : 'true'
                                }
                                onChange={(e) =>
                                  this.onExpiryDateChange(
                                    dateFnsCompat.setDate,
                                    e.target.value
                                  )
                                }
                              >
                                {fp.map((day) => (
                                  <option key={day} value={day}>
                                    {day}
                                  </option>
                                ))(
                                  fp.times((x) => x + 1)(
                                    dateFnsCompat.getDaysInMonth(
                                      this.state.content.expiryDate
                                    )
                                  )
                                )}
                              </select>
                            </FormField>
                          </Col>
                          <Col xs={12} md={4}>
                            <FormField
                              id='expiry-date-month'
                              label='Month'
                              type='select-item'
                              required
                            >
                              <select
                                id='expiry-date-month'
                                value={dateFnsCompat.getMonth(
                                  this.state.content.expiryDate
                                )}
                                required
                                aria-invalid={
                                  this.state.validation.expiryDate
                                    ? 'false'
                                    : 'true'
                                }
                                onChange={(e) =>
                                  this.onExpiryDateChange(
                                    dateFnsCompat.setMonth,
                                    e.target.value
                                  )
                                }
                              >
                                {noCapMap((month, index) => (
                                  <option key={index} value={index}>
                                    {month}
                                  </option>
                                ))(fp.values(months))}
                              </select>
                            </FormField>
                          </Col>
                          <Col xs={12} md={4}>
                            <FormField
                              id='expiry-date-year'
                              label='Year'
                              type='select-item'
                              required
                            >
                              <select
                                id='expiry-date-year'
                                value={dateFnsCompat.getYear(
                                  this.state.content.expiryDate
                                )}
                                required
                                aria-invalid={
                                  this.state.validation.expiryDate
                                    ? 'false'
                                    : 'true'
                                }
                                onChange={(e) =>
                                  this.onExpiryDateChange(
                                    dateFnsCompat.setYear,
                                    e.target.value
                                  )
                                }
                              >
                                {fp.flow(
                                  fp.concat(
                                    dateFnsCompat.getYear(
                                      this.state.content.expiryDate
                                    )
                                  ),
                                  fp.sortBy(fp.identity),
                                  fp.uniq,
                                  fp.map((year) => (
                                    <option key={year} value={year}>
                                      {year}
                                    </option>
                                  ))
                                )(
                                  fp.times((x) =>
                                    dateFnsCompat.getYear(
                                      dateFnsCompat.addYears(new Date(), x)
                                    )
                                  )(10)
                                )}
                              </select>
                            </FormField>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} md={12}>
                            <FormGroup
                              id='Expiry Date'
                              validation={
                                this.state.validation.expiryDate
                                  ? null
                                  : 'Expiry date must be in the future.'
                              }
                            ></FormGroup>
                          </Col>
                        </Row>
                      </fieldset>
                      <fieldset className='no-margin'>
                        <Row>
                          <Col xs={12}>
                            <FormItem>
                              <h2>CPD Hours Earned</h2>
                            </FormItem>
                            <p>Legislated CPD Area</p>
                            <Row className='xs-gutter'>
                              {fp.flow(
                                noCapMap(
                                  ({ industryId, cpdCategoryId, points }) => {
                                    const index =
                                      this.state.cpdCategorys.findIndex(
                                        (category) =>
                                          category.cpdCategoryId ===
                                            cpdCategoryId &&
                                          category.industryId === industryId
                                      );
                                    const selfIndustry = fp.filter(
                                      ({ industry }) =>
                                        industry.id === industryId
                                    )(this.props.industriesAvailable);
                                    const selfCategory = fp.filter(
                                      ({ id }) => id === cpdCategoryId
                                    )(fp.first(selfIndustry).cpdCategorys);

                                    return (
                                      <Col key={index} xs={12}>
                                        <Row className='xs-gutter'>
                                          {this.props.shouldChooseIndustry ? (
                                            <Col xs={3}>
                                              <SelectFormField
                                                formGroupProps={{
                                                  className: 'clearfix'
                                                }}
                                                id={`cpdCategory${index}`}
                                                name={`cpdCategorys[${index}].industryId`}
                                                label='Industry'
                                                disabled={this.isOriginalCpdCategoryRow(
                                                  index
                                                )}
                                                onChange={(e) =>
                                                  this.onContentIndustryChange(
                                                    cpdCategoryType.core,
                                                    index,
                                                    parseInt(e.target.value, 10)
                                                  )
                                                }
                                                required
                                                emptyOption={false}
                                                value={
                                                  industryId
                                                    ? `${industryId}`
                                                    : ''
                                                }
                                              >
                                                {fp.flow(
                                                  (industries) =>
                                                    industries.concat(
                                                      selfIndustry
                                                    ),
                                                  fp.sortBy('industry.name'),
                                                  fp.uniqBy('industry.id'),
                                                  fp.map(({ industry }) => (
                                                    <option
                                                      key={industry.id}
                                                      value={industry.id}
                                                    >
                                                      {he.decode(industry.name)}
                                                    </option>
                                                  ))
                                                )(
                                                  industriesWithAvailableCoreCategories
                                                )}
                                              </SelectFormField>
                                            </Col>
                                          ) : null}
                                          <Col
                                            xs={
                                              this.props.shouldChooseIndustry
                                                ? 6
                                                : 9
                                            }
                                          >
                                            <SelectFormField
                                              formGroupProps={{
                                                className: 'clearfix'
                                              }}
                                              id={`cpdCategory${index}`}
                                              name={`cpdCategorys[${index}].cpdCategoryId`}
                                              label='CPD Category'
                                              onChange={(e) =>
                                                this.onContentCpdCategoryChange(
                                                  index,
                                                  parseInt(e.target.value, 10)
                                                )
                                              }
                                              required
                                              emptyOption={false}
                                              value={
                                                cpdCategoryId
                                                  ? `${cpdCategoryId}`
                                                  : ''
                                              }
                                            >
                                              {fp.flow(
                                                fp.find(
                                                  ({ industry }) =>
                                                    industry.id === industryId
                                                ),
                                                fp.get('cpdCategorys'),
                                                filterActiveStatus,
                                                filterNonLegacyOrPublisherVisible,
                                                (industryCpdCategorys) =>
                                                  industryCpdCategorys.concat(
                                                    selfCategory
                                                  ),
                                                fp.uniqBy('id'),
                                                fp.sortBy((aoa) => aoa.name),
                                                fp.map(({ id, name }) => (
                                                  <option key={id} value={id}>
                                                    {he.decode(name)}
                                                  </option>
                                                ))
                                              )(
                                                industriesWithAvailableCoreCategories
                                              )}
                                            </SelectFormField>
                                          </Col>
                                          <Col xs={2}>
                                            <NumberFormField
                                              {...{
                                                id: `points${index}`,
                                                label: 'CPD Hours',
                                                min: 0,
                                                step: 0.25,
                                                onChange: (e) =>
                                                  this.setCpdPoints(
                                                    index,
                                                    e.value
                                                  ),
                                                required: true,
                                                value: points
                                              }}
                                            />
                                          </Col>
                                          {currentCoreCpdCategories.length >
                                            1 || this.props.business ? (
                                            <Col xs={1}>
                                              <Button
                                                bsStyle='plain'
                                                className='large area-of-advice-remove pull-right'
                                                onClick={() =>
                                                  this.removeContentCpdCategory(
                                                    index
                                                  )
                                                }
                                              >
                                                <Icon icon='close-thick' />
                                              </Button>
                                            </Col>
                                          ) : null}
                                        </Row>
                                      </Col>
                                    );
                                  }
                                )
                              )(currentCoreCpdCategories)}
                              <Col xs={12} className='flex-center'>
                                <Button
                                  onClick={() =>
                                    this.addAvailableCpdCategory(
                                      cpdCategoryType.core
                                    )
                                  }
                                  className='mt-3'
                                >
                                  <Icon icon='add-large' /> Add CPD Category
                                </Button>
                              </Col>
                            </Row>
                            <FormGroup
                              id='aoaCpdPoints-validation'
                              validation={
                                this.state.validation.aoaCpdPoints
                                  ? this.state.validation.aoaCpdPointsUnique
                                    ? null
                                    : 'You cannot list the same CPD category multiple times. Please update and try again.'
                                  : 'There must be at least one CPD category with non-zero CPD hours.'
                              }
                            ></FormGroup>
                            <p>ASIC Knowledge Area (if applicable)</p>
                            <Row className='xs-gutter'>
                              {fp.flow(
                                noCapMap(
                                  ({ industryId, cpdCategoryId, points }) => {
                                    const index =
                                      this.state.cpdCategorys.findIndex(
                                        (category) =>
                                          category.cpdCategoryId ===
                                            cpdCategoryId &&
                                          category.industryId === industryId
                                      );
                                    const selfIndustry = fp.filter(
                                      ({ industry }) =>
                                        industry.id === industryId
                                    )(this.props.industriesAvailable);
                                    const selfCategory = fp.filter(
                                      ({ id }) => id === cpdCategoryId
                                    )(fp.first(selfIndustry).cpdCategorys);
                                    return (
                                      <Col key={index} xs={12}>
                                        <Row className='xs-gutter'>
                                          {this.props.shouldChooseIndustry ? (
                                            <Col xs={3}>
                                              <SelectFormField
                                                formGroupProps={{
                                                  className: 'clearfix'
                                                }}
                                                id={`cpdCategory${index}`}
                                                name={`cpdCategorys[${index}].industryId`}
                                                label='Industry'
                                                onChange={(e) =>
                                                  this.onContentIndustryChange(
                                                    cpdCategoryType.sub,
                                                    index,
                                                    parseInt(e.target.value, 10)
                                                  )
                                                }
                                                required
                                                emptyOption={false}
                                                value={
                                                  industryId
                                                    ? `${industryId}`
                                                    : ''
                                                }
                                              >
                                                {fp.flow(
                                                  (industries) =>
                                                    industries.concat(
                                                      selfIndustry
                                                    ),
                                                  fp.sortBy('industry.name'),
                                                  fp.uniqBy('industry.id'),
                                                  fp.map(({ industry }) => (
                                                    <option
                                                      key={industry.id}
                                                      value={industry.id}
                                                    >
                                                      {he.decode(industry.name)}
                                                    </option>
                                                  ))
                                                )(
                                                  industriesWithAvailableSubCategories
                                                )}
                                              </SelectFormField>
                                            </Col>
                                          ) : null}
                                          <Col
                                            xs={
                                              this.props.shouldChooseIndustry
                                                ? 6
                                                : 9
                                            }
                                          >
                                            <SelectFormField
                                              formGroupProps={{
                                                className: 'clearfix'
                                              }}
                                              id={`cpdCategory${index}`}
                                              name={`cpdCategorys[${index}].cpdCategoryId`}
                                              label='CPD Category'
                                              onChange={(e) =>
                                                this.onContentCpdCategoryChange(
                                                  index,
                                                  parseInt(e.target.value, 10)
                                                )
                                              }
                                              required
                                              emptyOption={false}
                                              value={
                                                cpdCategoryId
                                                  ? `${cpdCategoryId}`
                                                  : ''
                                              }
                                            >
                                              {fp.flow(
                                                fp.find(
                                                  ({ industry }) =>
                                                    industry.id === industryId
                                                ),
                                                fp.get('cpdCategorys'),
                                                filterActiveStatus,
                                                filterNonLegacyOrPublisherVisible,
                                                (industryCpdCategorys) =>
                                                  industryCpdCategorys.concat(
                                                    selfCategory
                                                  ),
                                                fp.uniqBy('id'),
                                                fp.sortBy((aoa) => aoa.name),
                                                fp.map(({ id, name }) => (
                                                  <option key={id} value={id}>
                                                    {he.decode(name)}
                                                  </option>
                                                ))
                                              )(
                                                industriesWithAvailableSubCategories
                                              )}
                                            </SelectFormField>
                                          </Col>
                                          <Col xs={2}>
                                            <NumberFormField
                                              {...{
                                                id: `points${index}`,
                                                label: 'CPD Hours',
                                                min: 0,
                                                step: 0.25,
                                                onChange: (e) =>
                                                  this.setCpdPoints(
                                                    index,
                                                    e.value
                                                  ),
                                                required: true,
                                                value: points
                                              }}
                                            />
                                          </Col>
                                          {this.state.cpdCategorys.length > 0 ||
                                          this.props.business ? (
                                            <Col xs={1}>
                                              <Button
                                                bsStyle='plain'
                                                className='large area-of-advice-remove pull-right'
                                                onClick={() =>
                                                  this.removeContentCpdCategory(
                                                    index
                                                  )
                                                }
                                              >
                                                <Icon icon='close-thick' />
                                              </Button>
                                            </Col>
                                          ) : null}
                                        </Row>
                                      </Col>
                                    );
                                  }
                                )
                              )(currentSubCpdCategories)}
                              {subCategoriesWithIndustryId.length > 0 && (
                                <Col xs={12} className='flex-center'>
                                  <Button
                                    onClick={() =>
                                      this.addAvailableCpdCategory(
                                        cpdCategoryType.sub
                                      )
                                    }
                                    className='mt-3'
                                  >
                                    <Icon icon='add-large' /> Add Sub CPD
                                    Category
                                  </Button>
                                </Col>
                              )}
                            </Row>
                          </Col>
                        </Row>
                      </fieldset>

                      {this.props.business ? null : (
                        <fieldset>
                          <ControlGroup
                            id='content-progress-goal'
                            control='checkbox'
                            type='styled'
                            label={
                              <h3 className='no-margin'>
                                Please select if relevant
                              </h3>
                            }
                            onChange={() => {}}
                            onClick={(e) => this.onContentGoalChange(e)}
                            colProps={{ xs: 12, sm: 4 }}
                          >
                            {fp.flow(
                              fp.map(({ industry, goals }) =>
                                fp.map((goal) => ({
                                  ...goal,
                                  industryId: industry.id
                                }))(goals)
                              ),
                              fp.flatten,
                              fp.uniqBy('id'),
                              fp.map((goal) => (
                                <ControlOption
                                  {...this.contentGoalProps(goal)}
                                />
                              ))
                            )(this.props.industriesAvailable)}
                          </ControlGroup>
                        </fieldset>
                      )}

                      <fieldset className='tags-input'>
                        <h2>Add tags</h2>
                        <InputFormField
                          id='tag'
                          label='Add tag and press enter'
                          value={this.state.newTag}
                          onChange={(e) =>
                            this.setState({ newTag: e.target.value })
                          }
                          onKeyPress={(e) => this.onAddTagKeyPress(e)}
                        />
                        {this.state.tags.length ? (
                          <FormGroup>
                            <FormItem>
                              <div className='bootstrap-tagsinput'>
                                {fp.map((tag) => (
                                  <span
                                    key={tag}
                                    className='tag label label-info'
                                  >
                                    {he.decode(tag)}
                                    <span
                                      data-role='remove'
                                      aria-label={'Remove tag ' + tag}
                                      onClick={(e) => this.removeTag(tag)}
                                    />
                                  </span>
                                ))(this.state.tags)}
                              </div>
                            </FormItem>
                          </FormGroup>
                        ) : null}
                      </fieldset>
                      {!this.props.business ? (
                        <fieldset>
                          <h2>Upload preview image</h2>
                          {this.state.content.previewImageUrl &&
                          !this.state.previewImage ? (
                            <div>
                              <div className='text-center preview-image existing'>
                                <img
                                  alt={this.state.content.previewImageFileName}
                                  src={he.decode(
                                    this.state.content.previewImageUrl
                                  )}
                                />
                              </div>
                              <button
                                aria-label='Remove Image'
                                className='btn preview-image'
                                onClick={(e) => this.removeSavedImage(e)}
                              >
                                <Icon icon='close' />
                              </button>
                            </div>
                          ) : null}
                          {this.state.croppedImageUrl ? (
                            <div>
                              <div className='text-center preview-image existing'>
                                <img
                                  alt={this.state.previewImage.name}
                                  src={he.decode(this.state.croppedImageUrl)}
                                />
                              </div>
                              <button
                                aria-label='Remove Image'
                                className='btn preview-image'
                                onClick={(e) => this.removePreviewImage(e)}
                              >
                                <Icon icon='close' />
                              </button>
                            </div>
                          ) : null}
                          {!this.state.previewImage &&
                          !this.state.content.previewImageUrl ? (
                            <FileUploadFormField
                              styleName='file-5'
                              accept='image/png,image/jpeg'
                              multiple={false}
                              onFileDrop={this.onPreviewImageDrop}
                              file={this.state.previewImage}
                              maxSize={this.props.config.maxImageFileSizeBytes}
                              validationMessage={
                                this.state.validation.previewImage
                                  ? null
                                  : 'Please select image (JPG, PNG) file (max file size ' +
                                    prettyBytes(
                                      this.props.config.maxImageFileSizeBytes
                                    ) +
                                    ').'
                              }
                              dropLabel='Upload cover image (JPG, PNG)'
                            />
                          ) : null}
                        </fieldset>
                      ) : null}
                      <fieldset>
                        <ControlGroup
                          id='content-status'
                          control='radio'
                          type='styled'
                          label={<h2>Status</h2>}
                          validation={
                            this.state.validation.status
                              ? null
                              : 'Status is required.'
                          }
                          onChange={(e) => this.onContentStatusChange(e)}
                          colProps={{ xs: 12, sm: 4 }}
                        >
                          {fp.map((status) => (
                            <ControlOption
                              {...this.contentStatusProps(status)}
                            />
                          ))(contentStatus)}
                        </ControlGroup>
                      </fieldset>
                      {this.state.content.id ? (
                        <div>
                          <div id='review-question'>
                            <LinkContainer
                              name='review-question-btn'
                              className='btn-green large full'
                              to={{
                                pathname:
                                  this.props.libraryRouteRoot.contentQuestion,
                                search: `?${queryString.stringify({
                                  contentId: this.state.content.id,
                                  review: true
                                })}`
                              }}
                            >
                              <Button disabled={isFetchingContent}>
                                {isFetchingContent ? (
                                  <Spinner
                                    name='circle'
                                    className='spinner'
                                    fadeIn='none'
                                  />
                                ) : this.props.contentQuestions.length > 0 ? (
                                  'Review questions'
                                ) : (
                                  'Add questions'
                                )}
                              </Button>
                            </LinkContainer>
                          </div>
                          <div>
                            <ConfirmationModal
                              show={
                                this.state.content.id &&
                                this.state.showUpdateModal
                              }
                              actions={actions}
                              cancel={() => this.closeUpdateContent()}
                              message={updateContentConfirmationMessage({
                                cpdCategorysChanged,
                                passedUserEmails:
                                  this.props.contentPassedUserEmails
                              })}
                              headingText={<span>Update CPD Content</span>}
                            />
                            <Button
                              onClick={() =>
                                this.updateContent(cpdCategorysChanged)
                              }
                              className='large full'
                              disabled={isFetchingContent}
                            >
                              {isFetchingContent ? (
                                <Spinner
                                  name='circle'
                                  className='spinner'
                                  fadeIn='none'
                                />
                              ) : (
                                'Update Content'
                              )}
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <Button
                            onClick={(e) =>
                              this.saveContent({
                                event: e,
                                navigateToReviewQuestions: true
                              })
                            }
                            className='large full'
                            disabled={isFetchingContent}
                          >
                            {isFetchingContent ? (
                              <Spinner
                                name='circle'
                                className='spinner'
                                fadeIn='none'
                              />
                            ) : (
                              'Update content and add questions'
                            )}
                          </Button>
                          <Button
                            onClick={(e) => this.saveContent({ event: e })}
                            bsStyle='plain'
                            className='full'
                            disabled={isFetchingContent}
                          >
                            {isFetchingContent ? (
                              <Spinner
                                name='circle'
                                className='spinner'
                                fadeIn='none'
                              />
                            ) : (
                              'Skip adding questions for this content'
                            )}
                          </Button>
                        </div>
                      )}
                      {this.state.content.id &&
                      this.props.isSystemAdmin &&
                      !this.props.business ? (
                        <div className='delete-content'>
                          <ConfirmationModal
                            show={this.state.showDeleteModal}
                            actions={[
                              {
                                onConfirmAction: () => this.confirmDelete(),
                                actionLabel: 'Delete'
                              }
                            ]}
                            cancel={() => this.closeDeleteModal()}
                            message={
                              <p>
                                You are about to delete{' '}
                                <b>{this.state.content.title}</b>. &nbsp; Any
                                CPD earned by users for this content will also
                                be deleted.
                              </p>
                            }
                            headingText={<span>Delete Content</span>}
                          />
                          <Button
                            bsStyle='plain'
                            className='warning full large'
                            onClick={() => this.deleteContent()}
                          >
                            <Icon icon='delete-medium' /> Delete this content
                          </Button>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </form>
              )}
            </Col>
          </Row>
        </Grid>
        <Modal
          show={this.state.showingCroppingModal}
          dialogClassName='image-cropping-modal'
        >
          <Modal.Body>
            <ImageCropField
              className='text-center preview-image new'
              imageSrc={
                this.state.previewImage ? this.state.previewImage.preview : null
              }
              onComplete={this.onImageCropped}
              width={264}
              height={177}
            />
            <button
              aria-label='Remove Image'
              className='btn preview-image under-crop-field'
              onClick={(e) => this.removePreviewImage(e)}
            >
              <Icon icon='close' />
            </button>
          </Modal.Body>
        </Modal>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  publishers: activePublishersSelector(state),
  cpdCategorys: state.industry.cpdCategorys,
  config: contentConfigSelector(state),
  isSystemAdmin: fp.overSome([isSystemAdmin])(currentUserSelector(state)),
  currentUserIndustry: state.user.currentUserIndustry
});

const mapDispatchToProps = (dispatch) => ({});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    ({ industriesWithCpdCategorys, currentUserIndustry, business }) => ({
      industriesAvailable: business
        ? industriesWithCpdCategorys.filter(({ industry }) =>
            fp.contains(industry.id)(fp.map('id')(currentUserIndustry))
          )
        : industriesWithCpdCategorys
    })
  ),
  withProps(({ industriesAvailable }) => ({
    shouldChooseIndustry: industriesAvailable.length > 1
  }))
)(ContentDetails);



// WEBPACK FOOTER //
// ./src/containers/pages/shared/publish-content/content-details.js